import { render } from "./RefundDetail.vue?vue&type=template&id=89c75fee&scoped=true"
import script from "./RefundDetail.vue?vue&type=script&lang=js"
export * from "./RefundDetail.vue?vue&type=script&lang=js"

import "./RefundDetail.vue?vue&type=style&index=0&id=89c75fee&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c75fee"]])

export default __exports__